import { CertificateDetailsModel } from './certificate.model';
import { COMPANY } from './company.model';

export type PrivateDocumentItem = {
  name: string;
  productId: string;
  numberOfUnits: number;
};

export type PrivateDocumentModel<T extends PrivateDocumentItem> = {
  recipient: string;
  issuer: string;
  product: string;
  amount: string;
  number: string;
  totalValue?: number;
  orderNumber?: string;
  paymentDueDate?: string;
  invoiceNumber?: string;
  items: T[];
};

export type RFQItemModel = PrivateDocumentItem;

export type QuoteItemModel = PrivateDocumentItem & {
  unitPrice: number;
  totalPrice: number;
};

export type OrderItemModel = PrivateDocumentItem & {
  unitPrice: number;
  totalPrice: number;
};

export type InvoiceItemModel = PrivateDocumentItem & {
  batchNumber: string;
  countryOfOrigin: string;
  region?: string;
  factory?: string;
  unitPrice: number;
  totalPrice: number;
  orderNumber: number;
  linkedCertificateBlockchainAddress?: string;
};

export type PrivateDocumentItemFormModel = {
  name: string;
  productId: string;
  numberOfUnits: number;
  batchNumber?: string;
  countryOfOrigin?: string;
  region?: string;
  factory?: string;
  unitPrice?: number;
  totalPrice?: number;
  orderNumber?: number;
  linkedCertificateBlockchainAddress?: string;
};

export type PrivateDocumentFormModel = {
  recipient: COMPANY;
  number: string;
  documentTitle: string;
  documentContent: File;
  items: PrivateDocumentItemFormModel[];
};

export enum CATEGORY_TYPE {
  CERTIFICATE = 'certificate',
  RFQ = 'RFQ',
  QUOTE = 'QUOTE',
  ORDER = 'ORDER',
  INVOICE = 'INVOICE',
  CHEMISTRY = 'chemistry',
  BATTERY_CELLS = 'batteryCells',
  BATTERY_PACKS = 'batteryPacks',
  BATTERY_TECH_REVIEW = 'batteriesTechReview',
  BATTERY_PACKS_REPAIR = 'batteryPacksRepair',
  BATTERY_REPURPOSE = 'batteryRepurpose',
  BATTERY_PACKS_RECYCLING = 'batteryPacksRecycling',
  BATTERY_WASTE = 'batteryWaste',
  CHEMISTRY_TEST_RESULTS = 'chemistryTestResults',
  BATTERY_CELLS_TEST_RESULTS = 'batteryCellsTestResults',
  BATTERY_CELLS_SHIPPING_CONFIRMATION = 'batteryCellsShippingConfirmation',
  BATTERY_CELLS_RECEIVING_CONFIRMATION = 'batteryCellsReceivingConfirmation',
  BATTERY_PACKS_TEST_RESULTS = 'batteryPacksTestResults',
  CAR_DEALERS_SHIPPING_CONFIRMATION = 'carDealersShippingConfirmation',
}

export type CategoriesMappingModel = {
  [key in CATEGORY_TYPE]?: number;
};

export type DocumentInfoModel = {
  title: string;
  versionName?: string;
  categoryId: number;
  validSince: string;
  validUntil: string;
  retainUntil: string;
  publicationMode: string;
  identity?: {
    id: string;
  };
  receiverPublisherId?: string;
  additionalDetails:
    | PrivateDocumentModel<PrivateDocumentItemFormModel>
    | CertificateDetailsModel
    | Record<string, string>;
  draft?: boolean;
  previousDocumentBlockchainAddress?: string;
};
